/**
 * External dependencies
 */
import { __ } from '@wordpress/i18n';
import { isPostcode } from '@woocommerce/blocks-checkout';
import { isEmail, isPhoneNumber, isURL } from '@wordpress/url';

/**
 * Custom validation handler for fields with field specific handling.
 */
const customValidationHandler = (
	inputObject,
	validate
) => {

	// Pass validation if the field is not required and is empty.
	if ( ! inputObject.required && ! inputObject.value ) {
		return true;
	}

    if( validate === 'phone' && !isPhoneNumber( inputObject.value ) ) {
        inputObject.setCustomValidity(
			__( 'Please enter a valid Phone Number', 'woo-checkout-field-editor-pro' )
		);
        return false;
    }
 
    if ( validate === 'url' && ! isURL( inputObject.value ) ) {
        inputObject.setCustomValidity(
            __( 'Please enter a valid URL', 'woo-checkout-field-editor-pro' )
        );
        return false;
    }

	if ( validate === 'email' && ! isEmail( inputObject.value ) ) {
		inputObject.setCustomValidity(
			__( 'Please enter a valid email address', 'woo-checkout-field-editor-pro' )
		);
		return false;
	}

	return true;
};

export default customValidationHandler;
